import Vue from 'vue'
export default new Vue()


//////////////////
// WEBPACK FOOTER
// ./utils/eventBus.js
// module id = null
// module chunks = 